const addError = function (errorKey, payload) {
  return {
    type: 'ADD_ERROR',
    errorKey,
    payload,
  };
};

const removeError = function (errorKey) {
  return {
    type: 'REMOVE_ERROR',
    errorKey,
  };
};

export { addError, removeError };
